/* unplugin-vue-components disabled */import { mapState } from 'vuex';
export default {
  name: 'iHeaderLogo',
  computed: {
    ...mapState('admin/layout', ['isMobile', 'headerTheme'])
  }
};